<template>
  <Row type="flex" :justify=" windowWidth > 1280 ? 'space-around' : 'space-between'" align="middle" style="padding: 2vw 10vw 10vw 10vw;">
    <Col :style="{ 'max-width': imageWidth }" v-if="type === 'img-left'" :class="{'pad-top': isMobile}">
      <img :src="image" width="100%" v-if="image">
      <component v-if="component" :is="component" :isMobile="isMobile" :windowWidth="windowWidth" />
    </Col>
    <Col style="max-width: 450px" class="content-section">
      <h2 class="title">{{ title }}</h2>
      <p class="content" v-for="(desc, $index) in descriptions" :key="$index">{{ desc }}</p>
      <GetStartedButton v-if="cta" :arrow="true"></GetStartedButton>
    </Col>
    <Col :style="{ 'max-width': imageWidth }" v-if="type === 'img-right'" :class="{'pad-top': isMobile}">
      <img v-if="image" :src="image" width="100%">
      <component v-if="component" :is="component" :isMobile="isMobile" :windowWidth="windowWidth" />
    </Col>
  </Row>
</template>
<script>
import GetStartedButton from './GetStartedButton';

export default {
  components: { GetStartedButton },
  props: {
    isMobile: { type: Boolean },
    windowWidth: { type: Number, required: true },
    title: { type: String, required: true },
    descriptions: { type: Array, required: true },
    image: { type: String },
    component: { type: String },
    imageWidth: { type: String, default: '450px' },
    type: { type: String, enum: ['img-right', 'img-left'], default: 'img-right' },
    cta: { type: Boolean, default: false },
  },
};
</script>
<style lang="css" scoped>
.pad-top { margin-top: 20px; };

.content-section {}

.content-section .title {
  font-size: 28px;
}

.content-section .content {
  padding-top: 16px;
  padding-bottom: 16px;
  font-size: 1rem;
}

img {
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentImageSection.vue